import { CanActivateFn } from '@angular/router';
import { ProfileService } from '../../profile/services/profile.service';
import { inject } from '@angular/core';

export const rolesGuard: CanActivateFn = (route, state) => {
  const profileService = inject(ProfileService);
  if (profileService.profile()?.user_type?.access) {
    return true;
  }
  let res = false;
  // console.log('Role: ', profileService.profile()?.role)
  if (!profileService.profile()?.role){
    res = false;
  } else {
    res = true;
  }
  // console.log('rolesGuard: ', res);
  return res;
};
